/**
 * Specific selectors
 */
import { fromJS } from 'immutable';

const selectPluginTypeList = (state, pluginType) => (
  state.getIn(['author', 'plugins', pluginType])
);

const selectSelectedActivityIds = (state) => (
  state
    ?.getIn(['selectionState', 'coursewareItems', 0, 'ancestry'])
    ?.filter((ancestor) => ancestor.get('elementType') === 'ACTIVITY')
    ?.map((activity) => activity.get('elementId'))
    || fromJS([])
);

export {
  selectPluginTypeList,
  selectSelectedActivityIds,
};
